<template>
  <v-dialog v-model="active" width="650px">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="on" />
    </template>
    <v-card>
      <v-card-title>Lotes para atualização</v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <v-container fluid class="pa-0">
          <v-row class="ma-0">
            <v-simple-table class="full-width">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Produtor</th>
                    <th class="text-left">Data da alocação</th>
                    <th class="text-left">Motivo</th>
                    <th class="text-left">Valor Anterior</th>
                    <th class="text-left">Valor Novo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in filteredBatchesList"
                    :key="item['idProgramacaoAbateAlocado']"
                  >
                    <td>
                      {{ item["loteProducao"]["jsonProdutor"]["nmProdutor"] }}
                    </td>
                    <td>{{ item["dtAlocado"] | formatDate }}</td>
                    <td>{{ item["blBaixa"] ? "Baixa" : "Saída" }}</td>
                    <td>{{ item["qtAnimaisAlocados"] }}</td>
                    <td>{{ newValueByBatch(item) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn @click="active = false"> Fechar</v-btn>
        <v-spacer />
        <v-btn color="success" @click="onConfirmClick">Atualizar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex"
import * as moment from "moment";

export default {
  name: "ReallocateLotsDialog",
  data: () => ({
    active: false,
  }),
  methods: {
    onConfirmClick() {
      this.active = false;
      this.filteredBatchesList.forEach((item) =>  {
        this.setLoteAlocadoQtAnimais({
          idProgramacaoAbateAlocado: item.idProgramacaoAbateAlocado,
          value: parseInt(this.newValueByBatch(item)) || 0,
        });
      })
      this.filteredBatchesList.forEach(item => {
        item["blBaixa"] = false
      })
      this.$store.commit("setSnack", {
        type: "success",
        msg: "Lotes atualizados com sucesso"
      })
    },
    getQtdDisponiveis(item) {
      const sumTotalByLot = this.listBatchsAllocated.reduce((acc, curr) => {
        if (curr.cdLoteProducao === item.cdLoteProducao && !curr.blDeleted)
          acc += parseInt(curr.qtAnimaisAlocados) || 0;
        return acc;
      }, 0);

      return (
        (parseInt(item["qtSaldoReal"]) || 0) -
        (parseInt(item.loteProducao.qtAnimaisProgramadoAbate) || 0) -
        sumTotalByLot
      );
    },
    newValueByBatch(item) {
      if (!item["blBaixa"]) {
        const foundBatchWithBaixa = this.filteredBatchesList.find(
          (batch) =>
            batch["blBaixa"] &&
            batch["cdLoteProducao"] === item["cdLoteProducao"]
        );
        let newValue = foundBatchWithBaixa["qtAnimaisAlocados"] + this.getQtdDisponiveis(foundBatchWithBaixa);
        newValue = item["qtAnimaisAlocados"] + newValue
        return newValue
      } else {
        let newValue = item["qtAnimaisAlocados"] + this.getQtdDisponiveis(item);

        if (newValue < 0) newValue = 0;

        return newValue;
      }
    },
    ...mapActions("programacaoAbate",["setLoteAlocadoQtAnimais"])
  },
  filters: {
    formatDate(value) {
      const parsedDate = moment(value, "YYYY-MM-DD");
      if (!parsedDate.isValid()) return "";
      return parsedDate.format("DD/MM/YYYY");
    },
  },
  computed: {
    ...mapState("programacaoAbate", ["listBatchsAllocated"]),
    filteredBatchesList() {
      if (!this.listBatchsAllocated) return [];
      if (!this.listBatchsAllocated.length) return [];

      const batchesWithMortality = this.listBatchsAllocated.filter(
        (item) => item["blBaixa"] || item["blGta"]
      );

      const lotesProducaoToUpdate = [];
      batchesWithMortality.forEach((item) => {
        const qtdDisponiveis = this.getQtdDisponiveis(item);
        const newValue = item["qtAnimaisAlocados"] + qtdDisponiveis;
        if (newValue < 0) {
          lotesProducaoToUpdate.push(item["cdLoteProducao"]);
        }
      });

      lotesProducaoToUpdate.forEach((cdLoteProducao) => {
        const batch = this.listBatchsAllocated
          .sort((a, b) => a["dtAlocado"] - b["dtAlocado"])
          .find(
            (item) =>
              item["cdLoteProducao"] === cdLoteProducao &&
              item["qtAnimaisAlocados"] > 0 &&
              !item["blBaixa"] &&
              !item["blGta"]
          );
        batchesWithMortality.push(batch);
      });

      return batchesWithMortality;
    },
  },
};
</script>

<style scoped></style>
